// extracted by mini-css-extract-plugin
export default {"heart":"style_heart__ib7HY","fullHeight":"style_fullHeight__bAsQl"};